(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ubiyam-gummy-quiz"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ubiyam-gummy-quiz')) {
    class UbiyamGummyQuiz extends HTMLElement {
      connectedCallback() {
        if (this._init) return;
        this._init = true;
        this.questions = Array.from(this.querySelectorAll('[data-quiz-question]'));
        this.cards = Array.from(this.querySelectorAll('[data-quiz-card]'));
        this.total = this.questions.length;
        if (!this.total || !this.cards.length) return;

        this.stageQ = this.querySelector('[data-quiz-stage="questions"]');
        this.stageR = this.querySelector('[data-quiz-stage="result"]');
        this.bestBox = this.querySelector('[data-quiz-best]');
        this.moreBox = this.querySelector('[data-quiz-more]');
        this.restBox = this.querySelector('[data-quiz-rest]');
        this.fill = this.querySelector('[data-quiz-progress-fill]');
        this.stepLabel = this.querySelector('[data-quiz-progress-label]');
        this.becauseWrap = this.querySelector('[data-quiz-because-wrap]');
        this.becauseEl = this.querySelector('[data-quiz-because]');
        this.backBtns = Array.from(this.querySelectorAll('[data-quiz-back]'));
        this.answers = new Array(this.total).fill(null);
        this.step = 0;
        this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.questions.forEach((q, qi) => {
          q.querySelectorAll('[data-quiz-option]').forEach((opt) => {
            opt.addEventListener('click', () => this.choose(qi, opt));
          });
        });
        this.backBtns.forEach((b) => b.addEventListener('click', () => this.go(this.step - 1)));
        this.querySelectorAll('[data-quiz-restart]').forEach((b) => b.addEventListener('click', () => this.restart()));

        this.go(0);
      }

      go(i) {
        if (i < 0) i = 0;
        if (i >= this.total) return;
        this.step = i;
        this.questions.forEach((q, qi) => { q.hidden = qi !== i; });
        if (this.fill) this.fill.style.width = Math.round((i / this.total) * 100) + '%';
        if (this.stepLabel) this.stepLabel.textContent = 'Question ' + (i + 1) + ' of ' + this.total;
        this.backBtns.forEach((b) => { b.disabled = i === 0; });
        const ans = this.answers[i];
        this.questions[i].querySelectorAll('[data-quiz-option]').forEach((o) => {
          const on = !!(ans && o === ans.el);
          o.setAttribute('aria-pressed', on ? 'true' : 'false');
          o.classList.toggle('is-selected', on);
        });
      }

      choose(qi, opt) {
        const q = this.questions[qi];
        q.querySelectorAll('[data-quiz-option]').forEach((o) => {
          o.setAttribute('aria-pressed', 'false');
          o.classList.remove('is-selected');
        });
        opt.setAttribute('aria-pressed', 'true');
        opt.classList.add('is-selected');
        const weight = parseFloat(q.dataset.weight || '1') || 1;
        this.answers[qi] = {
          tags: opt.dataset.tags || '',
          weight: weight,
          label: opt.dataset.label || opt.textContent.trim(),
          el: opt,
        };
        clearTimeout(this._t);
        this._t = setTimeout(() => {
          if (qi >= this.total - 1) this.finish();
          else this.go(qi + 1);
        }, this.reduce ? 0 : 300);
      }

      finish() {
        if (this.fill) this.fill.style.width = '100%';
        if (this.stepLabel) this.stepLabel.textContent = '';

        const tally = {};
        this.answers.forEach((a) => {
          if (!a) return;
          a.tags.split(',').map((s) => s.trim()).filter(Boolean).forEach((t) => {
            tally[t] = (tally[t] || 0) + a.weight;
          });
        });

        this.cards.forEach((card, i) => {
          const traits = (card.dataset.traits || '').split(',').map((s) => s.trim()).filter(Boolean);
          let score = 0;
          for (const t in tally) {
            const w = tally[t];
            if (t.charAt(0) === '-') {
              if (traits.indexOf(t.slice(1)) !== -1) score -= 3 * w;
            } else if (traits.indexOf(t) !== -1) {
              score += w;
            }
          }
          card._score = score - i * 0.001;
        });

        const ranked = this.cards.slice().sort((a, b) => b._score - a._score);
        ranked.forEach((card, idx) => {
          const isBest = idx === 0;
          card.classList.toggle('ubiyam-quiz-card--best', isBest);
          const badge = card.querySelector('[data-quiz-match]');
          if (badge) badge.hidden = !isBest;
          const rank = card.querySelector('[data-quiz-rank]');
          if (rank) { rank.hidden = isBest; rank.textContent = isBest ? '' : String(idx + 1); }

          const img = card.querySelector('.ubiyam-quiz-card__img');
          if (img && img.dataset.bestSizes) {
            if (isBest) {
              if (img.dataset.smallSizes == null) img.dataset.smallSizes = img.getAttribute('sizes') || '';
              img.setAttribute('sizes', img.dataset.bestSizes);
            } else if (img.dataset.smallSizes != null) {
              img.setAttribute('sizes', img.dataset.smallSizes);
            }
          }
          card.hidden = false;
          if (isBest) this.bestBox.appendChild(card);
          else if (idx <= 3) this.moreBox.appendChild(card);
          else { card.hidden = true; this.restBox.appendChild(card); }
        });

        const q1 = this.answers[0];
        if (this.becauseWrap && this.becauseEl && q1) {
          this.becauseEl.textContent = q1.label;
          this.becauseWrap.hidden = false;
        }

        this.stageQ.hidden = true;
        this.stageR.hidden = false;
        this.stageR.scrollIntoView(this.reduce ? { block: 'start' } : { behavior: 'smooth', block: 'start' });
        const h = this.stageR.querySelector('h3');
        if (h && h.focus) h.focus();
      }

      restart() {
        this.answers = new Array(this.total).fill(null);
        this.stageR.hidden = true;
        this.stageQ.hidden = false;
        this.go(0);
        this.stageQ.scrollIntoView(this.reduce ? { block: 'start' } : { behavior: 'smooth', block: 'start' });
      }
    }
    customElements.define('ubiyam-gummy-quiz', UbiyamGummyQuiz);
  }

  } catch(e) { console.error(e); }
})();
})();
